var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19,
    stroke: "white",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1034_538)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.015 14.0171C28.6453 14.0171 27.3815 13.5633 26.3667 12.7979C25.2028 11.9204 24.3665 10.6332 24.0712 9.14959C23.9971 8.77655 23.9582 8.39739 23.955 8.01709H20.0423V18.7083L20.0376 24.5644C20.0376 26.1301 19.0181 27.4576 17.6048 27.9244C17.1815 28.0644 16.7356 28.1236 16.2904 28.0988C15.7017 28.0665 15.15 27.8888 14.6704 27.6019C13.65 26.9916 12.9581 25.8844 12.9393 24.6179C12.9098 22.6383 14.5101 21.0244 16.4882 21.0244C16.8787 21.0244 17.2537 21.0882 17.6048 21.204V17.2313C17.2345 17.1765 16.8576 17.1479 16.4765 17.1479C14.3114 17.1479 12.2864 18.0479 10.8389 19.6693C9.7448 20.8946 9.08855 22.4579 8.9873 24.0971C8.85465 26.2505 9.64262 28.2976 11.1707 29.8079C11.3953 30.0296 11.6311 30.2354 11.8776 30.4252C13.1878 31.4335 14.7895 31.9801 16.4765 31.9801C16.8576 31.9801 17.2345 31.9519 17.6048 31.8971C19.1807 31.6637 20.6348 30.9422 21.7823 29.8079C23.1923 28.4143 23.9714 26.5641 23.9798 24.5949L23.9596 15.8499C24.6339 16.37 25.3725 16.8007 26.1571 17.1315C27.3848 17.6494 28.6865 17.9119 30.0262 17.9115V14.0162C30.0271 14.0171 30.0159 14.0171 30.015 14.0171Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1034_538"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(7.5 7.99902)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.75f7d17fd02ba157d208750c973ce27c.svg";
export { ForwardRef as ReactComponent };